import {Component, OnInit, ViewChild} from '@angular/core';
import {EventsService} from '../../events.service';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import {isPlatformBrowser} from "@angular/common";
import {
    PerfectScrollbarConfigInterface,
    PerfectScrollbarComponent,
    PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';
import {GlobalService} from '../../../global.service';
declare const clickHeart:any;
import {EventDialogComponent} from '../../../Dialogs/event-dialog/event-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {Title} from "@angular/platform-browser";

@Component({
    selector: 'app-friend-zone',
    templateUrl: './friend-zone.component.html',
    styleUrls: ['./friend-zone.component.css']
})
export class FriendZoneComponent implements OnInit {

    mobileView: boolean = false;
    dialogRef;

    public config: PerfectScrollbarConfigInterface = {
        // suppressScrollX:true
    };
    @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
    @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;

    games: Array<any> = ['rainbow-six-siege', 'pubg-lite', 'fortnite', 'pubg', 'league-of-legends'];
    gamePic = null;
    gameText = null;
    gameName = null;

    constructor(public dialog: MatDialog, private globalService: GlobalService, private router: Router, private activeRoute: ActivatedRoute,
                public eventService: EventsService , private titleService:Title) {
      this.titleService.setTitle('Friend Zone')
      if (this.globalService.isBrwoser) {
            if (window.screen.width < 768) {
                this.mobileView = true;
            }
        }
        router.events.subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.eventService.insomniaGame = event.url.split('/')[1];
                    this.changeGame(this.eventService.insomniaGame)
                }
            }
        );
    }

    ngOnInit() {

      if(this.router.url.split('/')[1].includes('?')) {
        this.eventService.insomniaGame = this.router.url.split('/')[1].substring(0, this.router.url.split('/')[2].indexOf("?"));
        this.changeGame(this.eventService.insomniaGame)
      }
        // clickHeart();
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {

              this.eventService.insomniaGame = event.url.split('/')[2];
                this.changeGame(this.eventService.insomniaGame)

            }
        });
        if (this.router.url.split('/').length < 3) {
            this.router.navigateByUrl('/friend-zone/');
        }
    }

    multidialog(dialogType) {
        if (this.dialogRef)
            this.dialogRef.close('')
        this.dialogRef = this.dialog.open(EventDialogComponent, {
            data: {
                type: dialogType
            },
            width: '500px',
            height:'500px'
        });
    }

    chooseGame(game) {
        if (game == 'pubg')
            this.router.navigateByUrl('/friend-zone/pubg');
        else if (game == 'league-of-legends')
            this.router.navigateByUrl('/friend-zone/league-of-legends');
        else if (game == 'fortnite')
            this.router.navigateByUrl('/friend-zone/fortnite');
        else if (game == 'pubg-lite')
            this.router.navigateByUrl('/friend-zone/pubg-lite');
        else if (game == 'rainbow-six-siege')
            this.router.navigateByUrl('/friend-zone/rainbow-six-siege');
        else if (game == 'league-of-legends')
            this.router.navigateByUrl('/friend-zone/league-of-legends');
        else
            this.router.navigateByUrl('/friend-zone/');
    }

    changeGame(game) {
        if (game == 'pubg') {
            this.gamePic = "assets/img/friend-zone/games/pubg/banner.jpg";
            this.gameText = "Land, Loot, Survive, There is no love in here.";
            this.gameName = 'pubg';
        } else if (game == 'league-of-legends') {
            this.gamePic = "assets/img/friend-zone/games/league-of-legends/banner.jpg";
            this.gameText = "F-R-I-E-N-D-S That's how you spell friends";
            this.gameName = 'league-of-legends';
        } else if (game == 'fortnite') {
            this.gamePic = "assets/img/friend-zone/games/fortnite/banner.jpg";
            this.gameText = "You are the best brother I ever had";
            this.gameName = 'fortnite';
        } else if (game == 'rainbow-six-siege') {
            this.gamePic = "assets/img/friend-zone/games/rainbow-six-siege/banner.jpg";
            this.gameText = "You are too good to me. It's not you, It's me.";
            this.gameName = 'rainbow-six-siege';
        } else if (game == 'pubg-lite') {
            this.gamePic = "assets/img/friend-zone/games/pubg-lite/banner.jpg";
            this.gameText = "You say you love me, I say you crazy. We're nothing more than friends";
            this.gameName = 'pubg-lite';
        } else {
            this.gamePic = null;
        }
    }
}
